import { IconsEnum } from '../../../../../../../assets/icons/types';

import { SimpleModal } from '../../../../../../../helpers/modals/SimpleModal';
import { Icon } from '../../../../../../../helpers/Icon';
import { PureButtonHelper } from '../../../../../../../helpers/buttons/PureButtonHelper';
import { Translate } from '../../../../../../../helpers/Translate';

import { modelViewersKeys, words } from '../../../../../../../locales/keys';

interface ModelViewerCloseConfirmationModalProps {
  isOpen: boolean;
  onGoBack: () => void;
  onCloseAnyway: () => void;
}

// Rendered inside the model viewer modal's Dialog tree so Headless UI stacks
// the dialogs: while this confirmation is open, Esc and outside clicks reach
// only the confirmation (hideModal -> onGoBack), never the viewer modal.
// Go back comes first in the DOM (reversed visually by flex-*-reverse) so the
// focus trap's first-focusable fallback lands on it, not on Close anyway.
function ModelViewerCloseConfirmationModal({
  isOpen,
  onGoBack,
  onCloseAnyway
}: ModelViewerCloseConfirmationModalProps) {
  return (
    <SimpleModal
      childrenClassName="px-4 pt-5 pb-4 sm:p-6"
      hideModal={onGoBack}
      isOpen={isOpen}
      modalSize="md"
      withoutButtons
    >
      <div className="sm:flex sm:items-start gap-4">
        <div className="mx-auto shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10 bg-yellow-100">
          <Icon
            className="h-6 w-6 text-yellow-600"
            icon={IconsEnum.EXCLAMATION}
          />
        </div>

        <div className="mt-3 text-center sm:mt-0 sm:text-left">
          <h3 className="text-lg leading-6 font-medium">
            <Translate id={modelViewersKeys.closeWithoutSavingTitle} />
          </h3>

          <div className="mt-2">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              <Translate id={modelViewersKeys.closeWithoutSavingDescription} />
            </p>
          </div>
        </div>
      </div>

      <div className="mt-5 sm:mt-4 sm:ml-10 sm:pl-4 flex flex-col-reverse sm:flex-row-reverse sm:justify-end">
        <PureButtonHelper
          className="mt-3 w-full inline-flex justify-center rounded-md border border-transparent text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 px-4 py-2 text-base font-medium shadow-sm sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          i18nText={words.goBack}
          onClick={onGoBack}
        />

        <PureButtonHelper
          className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm hover:shadow-md px-4 py-2 text-base font-medium text-white sm:w-auto sm:text-sm bg-yellow-600 hover:bg-yellow-700"
          i18nText={modelViewersKeys.closeAnyway}
          onClick={onCloseAnyway}
        />
      </div>
    </SimpleModal>
  );
}

export default ModelViewerCloseConfirmationModal;
